var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-progress-circular',{staticClass:"d-block",attrs:{"indeterminate":"","width":_vm.width,"size":_vm.size,"color":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }